import Link from "../Link";
import LanguageSwitcher from "./language-switcher";
import { useTranslation, Trans } from "next-i18next";
import Image from "next/image";
import styles from '../../styles/scss/_footer.module.scss'

const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === "production" || process.env.NODE_ENV === "production";
export default function FooterV2() {
  const { t } = useTranslation("footer");
  let footerItems = [
    {
      title: `${t('aboutCompanyName.product')}`,
      footerLinks: [
        {
          title: `${t('productsName.overview')}`,
          link: '/product/'
        },
        {
          title: `${t('productsName.infrastructureMonitoring')}`,
          link: '/product/infrastructure-monitoring/'
        },
        {
          title: `${t('productsName.logMonitoring')}`,
          link: '/product/log-monitoring/'
        },
        {
          title: `${t('productsName.APM')}`,
          link: '/product/apm/'
        },
        {
          title: `${t('productsName.metrics')}`,
          link: '/product/metrics/'
        },
        {
          title: `${t('productsName.distributedTracing')}`,
          link: '/product/distributed-tracing/'
        },
        {
          title: `${t('productsName.databaseMonitoring')}`,
          link: '/product/database-monitoring/'
        },
        {
          title: `${t('productsName.realUserMonitoring')}`,
          link: '/product/real-user-monitoring/',
        },
        {
          title: `${t('productsName.syntheticMonitoring')}`,
          link: '/product/synthetic-monitoring/'
        },
        {
          title: `${t('productsName.containerMonitoring')}`,
          link: '/product/container-monitoring/'
        },
        {
          title: `${t('productsName.serverlessMonitoring')}`,
          link: '/product/serverless-monitoring/'
        },
        {
          title: `${t('productsName.llmMonitoring')}`,
          link: '/product/llm-observability/'
        },
        {
          title: `${t('productsName.browserTesting')}`,
          link: '/product/browser-testing/'
        },
        {
          title: `${t('productsName.opsAIAgent')}`,
          link: '/product/ops-ai/'
        },
        {
          title: `${t('productsName.statusPage')}`,
          link: '/product/status-page/'
        },
      ]
    },
    {
      title: `${t('aboutCompanyName.ourPlatform')}`,
      footerLinks: [
        {
          title: `${t('platformName.overview')}`,
          link: '/platform/'
        },
        {
          title: `${t('platformName.unifiedExperience')}`,
          link: '/platform/unified-experience/'
        },
        {
          title: `${t('platformName.alerts')}`,
          link: '/platform/alerts/'
        },
        {
          title: `${t('platformName.dashboardMonitoring')}`,
          link: '/platform/dashboard/'
        },
        {
          title: `${t('platformName.noteBookMonitoring')}`,
          link: '/platform/notebook/'
        },
        {
          title: `${t('platformName.queryLanguage')}`,
          link: '/platform/query-language/'
        },
        {
          title: `${t('platformName.pipeline')}`,
          link: '/platform/observability-pipeline/'
        },
        {
          title: `${t('platformName.integrations')}`,
          link: '/platform/integrations/'
        },
        {
          title: `${t('platformName.sessionReplay')}`,
          link: '/product/real-user-monitoring/session-replays/'
        },
        {
          title: `${t('platformName.errorTracking')}`,
          link: '/product/real-user-monitoring/error-tracking/'
        },
        {
          title: `${t('platformName.continuousProfiler')}`,
          link: '/product/continuous-profiler/'
        },
        {
          title: `${t('platformName.queryGenie')}`,
          link: '/product/query-genie/'
        },
      ]
    },
    {
      title: `${t('aboutCompanyName.ourSolution')}`,
      footerLinks: [
        // {
        //   title:'Digital Experience Monitoring',
        //   link:'/solutions/digital-experience-monitoring/'
        // },
        // {
        //   title:'Industry',
        //   link:'/solutions/industry/'
        // },
        {
          title: `${t('solutionsName.technology')}`,
          link: '/solutions/technology/'
        },
        {
          title: `${t('solutionsName.aws')}`,
          link: '/solutions/aws/'
        },
        {
          title: `${t('solutionsName.azure')}`,
          link: '/solutions/azure/',
        },
        {
          title: `${t('solutionsName.gcp')}`,
          link: '/solutions/gcp/',
        },
        {
          title: `${t('solutionsName.kubernetesMonitoring')}`,
          link: '/solutions/kubernetes-monitoring/',
        },
        {
          title: `${t('solutionsName.endpointMonitoring')}`,
          link: '/solutions/endpoint-monitoring/'
        },
      ],
      subItem: [
        {
          title: `${t('aboutCompanyName.comparison')}`,
          footerLinks: [
            {
              title: `${t('aboutCompanyName.datadogAlternative')}`,
              link: '/comparison/datadog-alternative/'
            },
            {
              title: `${t('aboutCompanyName.newrelicAlternative')}`,
              link: '/comparison/newrelic-alternative/'
            },
            {
              title: `${t('aboutCompanyName.dynatraceAlternative')}`,
              link: '/comparison/dynatrace-alternative/'
            },
            {
              title: `${t('aboutCompanyName.grafanaAlternative')}`,
              link: '/comparison/grafana-vs-middleware/'
            },
            {
              title: `${t('aboutCompanyName.coralogixAlternative')}`,
              link: '/comparison/coralogix-vs-middleware/'
            },
          ]
        },
      ]
    },
    {
      title: `${t('aboutCompanyName.resources')}`,
      footerLinks: [
        {
          title: `${t('resourcesName.customers')}`,
          link: '/customers/'
        },
        {
          title: `${t('resourcesName.community')}`,
          link: 'https://community.middleware.io',
          newTab: true
        },
        {
          title: `${t('resourcesName.events')}`,
          link: '/events/'
        },
        {
          title: `${t('resourcesName.webinar')}`,
          link: '/webinar/'
        },
        {
          title: `${t('resourcesName.whitepapers')}`,
          link: '/whitepaper/'
        },
        {
          title: `${t('resourcesName.knowledgeCenter')}`,
          link: '/knowledge/'
        },
        {
          title: `${t('resourcesName.newsletter')}`,
          link: 'https://newsletters.middleware.io/',
          newTab: true
        },
        {
          title: `${t('resourcesName.mediaCoverage')}`,
          link: '/resources/media-coverage/'
        },
        {
          title: `${t('resourcesName.blog')}`,
          link: '/blog/'
        },
        // {
        //   title:'Techscribe',
        //   link:'/technical-writer-program/'
        // },
        ,
        {
          title: `${t('resourcesName.guides')}`,
          link: '/topics/',
        },
        {
          title: `${t('resourcesName.helpDocs')}`,
          link: 'https://docs.middleware.io',
          newTab: true
        },
        {
          title: `${t('resourcesName.apiDocs')}`,
          link: 'https://docs.middleware.io/public-api/api',
          newTab: true
        },
        {
          title: `${t('resourcesName.productUpdates')}`,
          link: '/product-updates/',
        },
        {
          title: `${t('resourcesName.podcasts')}`,
          link: '/podcast/',
        },
        {
          title: `${t('resourcesName.observabilityForecast')}`,
          link: '/observability-survey-2026/',
        }

      ]
    },
    {
      title: `${t('aboutCompanyName.company')}`,
      footerLinks: [
        {
          title: `${t('aboutCompanyName.aboutUs')}`,
          link: '/about-us/'
        },
        {
          title: `${t('aboutCompanyName.careers')}`,
          link: '/careers/'
        },
        {
          title: `${t('aboutCompanyName.partner')}`,
          link: '/partners/'
        },
        {
          title: `${t('aboutCompanyName.contactUs')}`,
          link: '/contact-us/'
        },
        {
          title: `Assets`,
          link: '/brand-assets/'
        },
      ],
      subItem: [
        {
          title: `${t('aboutCompanyName.security')}`,
          footerLinks: [
            {
              title: `${t('aboutCompanyName.security')}`,
              link: '/security/'
            },
            {
              title: `${t('aboutCompanyName.GDPR')}`,
              link: '/gdpr/'
            },
          ]
        },
      ]
    },
  ]
  let socialIcons = [
    {
      icon: '/images/social-icon/linkdIn.svg',
      link: 'https://www.linkedin.com/company/middleware-labs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon: '/images/social-icon/git.svg',
      link: 'https://github.com/middleware-labs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon: '/images/social-icon/twitter.svg',
      link: 'https://twitter.com/middleware_labs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon: '/images/social-icon/youtube.svg',
      link: 'https://www.youtube.com/channel/UCjYP2EQiEgHryxR0dgpt0YA/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon: '/images/social-icon/slack.svg',
      link: 'https://middlewarepublic.slack.com/join/shared_invite/zt-39l76rpo6-ZNGfpA_4U_kYL6oTuYAgmQ',
      class: 'social-icon',
      newTab: true
    },
    {
      icon: '/images/social-icon/facebook.svg',
      link: 'https://www.facebook.com/middlewarelabs/',
      class: 'social-icon',
      newTab: true
    },
    {
      icon: '/images/social-icon/community.svg',
      link: 'https://community.middleware.io',
      class: 'social-icon',
      newTab: true
    }
  ]

  const year = new Date().getFullYear();
  return (
    <footer className={styles.footerSection}>
      <div className={'site-footer'}>
        <div className={'container'}>

        <div className="g2-badges">
          <div className="d-flex">
            <div className="reviews">
              <Image src={"/images/g2-crowd-reviews.svg"} alt={"G2 Crowd Reviews"} width={"100"} height={"100"} />
              <Link href={'https://www.g2.com/products/middleware/reviews'} target={"_blank"} className="g2-link">G2 Reviews</Link>
            </div>
            <div className="g2-performer">
              <Image src={"/images/g2-reviews-v2.svg"} alt={"G2 High Performer"} width={"100"} height={"100"}  />
            </div>
          </div>
        </div>

          <div className={'footer-links'}>
            {footerItems.map((item, index) => {
              return <div className={'link-wrapper'} key={index}>
                <div className="footer-heading">{item.title}</div>
                <ul>
                  {item.footerLinks.map((__item, __index) => (
                    <li key={__index}>
                      <Link key={__item.title + __index} href={__item.link} target={__item.newTab ? "_blank" : ""}>
                        {__item.title}
                        {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"} />}
                      </Link>
                    </li>
                  ))}

                  {item.subItem && item.subItem.map((__sub, index) => (
                    <li key={index} className="sub-menu-item">
                      <div className="footer-heading">{__sub.title}</div>
                      <ul>
                        {__sub.footerLinks.map((__item1, __index) => (
                          <li key={__index}>
                            <Link key={__item1.title + __index} href={__item1.link}>{__item1.title}</Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>

              </div>
            })}
          </div>

          <div className={"footer-logos"}>
            <div className={"d-flex"}>
              <div className={"item-logo"}>
                <Link href={'/'}><div className={'logo-footer'}><img src={"/images/logo-mw-white.svg"} alt={"Middleware’s white logo"} loading={'lazy'} width={'215'} height={'28'} /></div></Link>
              </div>
              <div className={"item-logo"}>
                <div className={"soc-gdpr"}>
                  <img src={"/images/gdpr-footer.svg"} alt={"GDPR"} width={"100"} height={"100"} loading={"lazy"} />
                  <img src={"/images/soc2type.svg"} alt={"SOC-2 Type II"} width={"100"} height={"100"} loading={"lazy"} className="soc2" />
                  <img src={"/images/hipaa.svg"} alt={"HIPAA"} width={"100"} height={"100"} loading={"lazy"} className={"hipaa"} />
                  <img src={"/images/iso-27001.svg"} alt={"ISO 27001"} width={"100"} height={"100"} loading={"lazy"} className={"iso"} />
                </div>
              </div>
              <div className={"item-logo"}>
                <div className={'d-flex social-icons'}>
                  {socialIcons.map((item, index) => {
                    return <Link href={item.link} key={index} target={item.newTab ? "_blank" : "_self"}><div className={item.class} >
                      <img src={item.icon} alt={'social-icon'} loading={'lazy'} width={'28'} height={'28'}></img>
                    </div></Link>
                  })}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className={'footer-bottom-area'}>
        <div className={"container"}>
          <div className={'d-flex'}>
            <p>©{year} Middleware, All rights reserved</p>
            <ul>
              <li><Link href={"/privacy-policy/"}>{t('aboutCompanyName.privacyPolicy')}</Link></li>
              <li><Link href={"/terms-and-conditions/"}>{t('aboutCompanyName.termsConditions')}</Link></li>
              <li><Link href={"/cookie-policy/"}>{t('aboutCompanyName.cookiePolicy')}</Link></li>
              <li><Link href={"/master-subscription-agreement/"}>{t('aboutCompanyName.masterSubscriptionAgreement')}</Link></li>
              {!isProd && <li>
                  <div className={'language-switcher-wrapper'}>
                      <LanguageSwitcher />
                  </div>
                </li>}
            </ul>
          </div>
        </div>
      </div>

    </footer>
  )
}
